import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, setPlayerName, set_dbSavedTimeStamp } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './NAE.css';
import backIcon2 from '../../../Assests/backIcon2.svg'
import { firebaseServices } from '../../../Firebase/FirebaseServices'
import BrowserDetect from '../../../Functions/BrowserDetect';

var viewWidth = window.innerWidth;
var viewHeight = window.innerHeight;

function NameAndEmail() {
    let [isLoading, setIsLoading] = useState(false)
    let [email, setEmail] = useState('');
    let [name, setName] = useState('');
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);

    useEffect(() => {
        setTimeout(function () { setIsLoading(false) }, 100);
        viewWidth = window.innerWidth;
        viewHeight = window.innerHeight;
        firebaseServices.auth().signInAnonymously()
    }, [])

    if (isLoading === true) {
        return (<div className="LS_mainDiv"></div>)
    } else {
        return (
            <div className='NAE_imageAnimate'>
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className='NAE_entryBox'>
                    <div className="NAE_heading">
                        {language === 'english' ?
                            <p className="NAE_headingEnglish">Help Saira</p> :
                            <p className="NAE_headingUrdu"> سائرا کو مدد چاہیے</p>
                        }
                    </div>

                    <div className='NAE_inputFields'>
                        <form>
                            <label className='NAE_inputFieldsLabelText'>
                                {language === 'english' ? 'Enter name to continue' : 'جاری رکھنے کے لئے اپنا نام درج کریں'}
                                <input type="text" className="form-control NAE_input"
                                    onChange={(e) => { setName(e.target.value) }} />
                            </label>
                        </form>

                        <form>
                            <label className='NAE_inputFieldsLabelText'>
                                {language === 'english' ? 'Email' : 'ای میل'}
                                <input type="text" className="form-control NAE_input"
                                    onChange={(e) => { setEmail(e.target.value) }} />

                            </label>
                        </form>

                    </div>

                    <div className='NAE_buttonDiv'>
                        <button onClick={() => {
                            if (name !== '' && email !== '') {
                                dispatch(pageUp())
                                dispatch(setPlayerName(name))
                                logDetails(name, email, language, dispatch);
                            } else {
                                alert('Please fill the required fields')
                            }
                        }}
                            className='NAE_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>



            </div>
        )
    }
}

export default NameAndEmail;


function logDetails(name, email,language, dispatch) {
    let timeStamp = new Date().toString();
    dispatch(set_dbSavedTimeStamp(timeStamp));
    firebaseServices.database().ref(`/userDetails/${timeStamp}/`).set
        ({
            name: name,
            email: email,
            viewPorts: `vw:${viewWidth} x vh:${viewHeight}`,
            breakpoint: `${getBreakpointCategory(viewWidth, viewHeight)}`,
            browser: BrowserDetect(),
            language: language,
            episode1:{episode1_Clicked: 'false', episode1_lastVisitFrame:'0',episode1_Score: '0'},
            episode2:{episode2_Clicked: 'false', episode2_lastVisitFrame:'0',episode2_Score: '0'},
            episode3:{episode3_Clicked: 'false', episode3_lastVisitFrame:'0',episode3_Score: '0'},
        })
}

function getBreakpointCategory(vw, vh) {
    if (vw >= 1 && vw <= 767)
        return ('1- Extra Small Devices, Phones')
    else if (vw >= 768 && vw <= 991)
        return ('2- Small Devices, Tablets')
    else if (vw >= 992 && vw <= 1199)
        return ('3- Medium Devices, Desktops')
    else if (vw >= 1200)
        return ('4- Large Devices, Wide Screens')
    else
        return ('error getting dimentions')

}